/**
 * Multi-field table filters (leases, units, tenants, transactions, service
 * requests): when false, users must click Apply — field changes do not reload.
 *
 * Flip to `true` to restore legacy desktop auto-submit on Select/DatePicker
 * change (mobile already used Apply). ResponsiveFilterPanel hides the desktop
 * Apply/Clear row when this is true.
 */
export const FILTER_AUTO_SUBMIT_ON_CHANGE = false;

/** Call from filter field onChange / onBlur when legacy auto-submit may apply. */
export function maybeSubmitFiltersOnChange(
  submit: () => void,
  options?: { isMobile?: boolean },
): void {
  if (!FILTER_AUTO_SUBMIT_ON_CHANGE) return;
  // Legacy behavior: only desktop auto-submitted on change.
  if (options?.isMobile) return;
  submit();
}
